import { Loader2, PlayCircle, StopCircle, Wrench, XCircle, Clock } from "lucide-react";

const map = {
  running: { cls: "status-running", label: "Running", bg: "hsl(173 80% 22%)", fg: "hsl(166 76% 92%)" },
  stopped: { cls: "status-stopped", label: "Stopped", bg: "hsl(222 18% 22%)", fg: "hsl(210 20% 86%)" },
  building: { cls: "status-building", label: "Building", bg: "hsl(35 92% 28%)", fg: "hsl(33 100% 92%)" },
  failed: { cls: "status-failed", label: "Failed", bg: "hsl(0 72% 30%)", fg: "hsl(0 100% 94%)" },
  pending: { cls: "status-pending", label: "Pending", bg: "hsl(222 18% 22%)", fg: "hsl(210 20% 86%)" },
};

export function StatusBadge({ status, testid }) {
  const s = map[status] || map.pending;
  return (
    <span
      data-testid={testid || "status-badge"}
      className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-medium border"
      style={{ background: s.bg, color: s.fg, borderColor: "transparent" }}
    >
      <span className={`status-dot ${s.cls}`} />
      {s.label}
    </span>
  );
}
